import * as React from 'react'
import * as t from 'io-ts'
import * as UUID from 'uuid'
import { Button, Col, Form, Icon, Input, notification, Row, Spin } from 'antd'
import { connect } from 'react-redux'
import { FormComponentProps } from 'antd/lib/form'
import { FormEvent } from 'react'
import { loginActions } from './login.actions'
import { Option } from 'fp-ts/lib/Option'
import { ordString } from 'fp-ts/lib/Ord'
import { set } from 'fp-ts'
import { startFetch } from 'src/framework/fetch-reducer'
import { State } from 'src/app.store'
import { UserIdentity } from './login.reducer'
import './Login.css'
import { either } from 'fp-ts/lib/Either'
import { style } from 'typestyle'

const FormItem = Form.Item

export const onLoginFailure = () => {
  notification.open({
    message: 'Connexion échouée',
    description: 'La connexion a échoué',
    icon: <Icon type="warning" style={{ color: '#F00' }} />,
    duration: 2
  })
}

export const onForgotNoEmail = () => {
  notification.open({
    message: 'Adresse email invalide',
    description: 'Merci de saisir une adresse email valide',
    icon: <Icon type="warning" style={{ color: '#F00' }} />,
    duration: 2
  })
}

interface SendLoginActions {
  doLogin: (email: string, password: string, correlationId: string) => void
  forgotPassword: (email: string) => void
  forgotPasswordInvalid: () => void
}

const userCredentials = t.interface({
  email: t.string,
  password: t.string
})

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />

const loginStyle = style({
  backgroundColor: '#fff',
  padding: '1.5rem 2.5rem',
  fontFamily: "'Titillium Web', sans-serif",
  border: '1px solid #c2cfd6'
})

interface LoginCompState {
  processingId: string
}

export const isMember = set.elem(ordString)

interface NormalLoginFormProps {
  isFetching: (id: string) => boolean
  identity: Option<UserIdentity>
}

class NormalLoginForm extends React.Component<
  FormComponentProps & SendLoginActions & NormalLoginFormProps,
  LoginCompState
> {
  constructor(props: any) {
    super(props)
    this.state = { processingId: '-' }
  }

  handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    this.props.form.validateFields((err: unknown, values: unknown) => {
      if (!err) {
        either.map(userCredentials.decode(values), ({ email, password }) => {
          const correlationId = UUID.v4()
          this.setState({ processingId: correlationId })
          this.props.doLogin(email, password, correlationId)
        })
      }
    })
  }
  onForgetEmail = (e: React.SyntheticEvent<any>) => {
    e.preventDefault()
    const email = this.props.form.getFieldValue('email')
    const emailError = this.props.form.getFieldError('email')
    const noErrors = emailError === undefined || emailError.length === 0
    if (email !== undefined && noErrors) {
      this.props.forgotPassword(email)
    } else {
      this.props.forgotPasswordInvalid()
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const emailEntered = this.props.form.getFieldValue('email') !== undefined
    const emailErrors = this.props.form.getFieldError('email') as object[] | undefined
    const submitEnabled = emailEntered && emailErrors === undefined

    return (
      <div className={loginStyle}>
        <h1>Se connecter</h1>

        <Form onSubmit={this.handleSubmit}>
          <FormItem className="form-item-custom-style">
            {getFieldDecorator('email', {
              rules: [
                {
                  type: 'email',
                  message: "L'email n'est pas valide"
                },
                { required: true, message: 'Merci de saisir votre adresse email' }
              ]
            })(<Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Email" />)}
          </FormItem>
          <FormItem className="form-item-custom-style">
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Merci de saisir votre mot de passe' }]
            })(
              <Input
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder="Mot de passe"
              />
            )}
          </FormItem>
          <Row type="flex" justify="space-between">
            <Col xs={24} sm={10} xl={8}>
              <FormItem className="login-form-item">
                <Button type="primary" htmlType="submit" className="login-form-button" disabled={!submitEnabled}>
                  Se connecter
                </Button>
              </FormItem>
            </Col>
            <Col xs={24} sm={10} xl={8}>
              <FormItem className="login-form-item">
                <Button type="default" className="login-form-button" onClick={this.onForgetEmail}>
                  Mot de passe oublié
                </Button>
              </FormItem>
            </Col>
          </Row>
          <Row>
            {this.props.isFetching(this.state.processingId) ? (
              <div className="centerCenter">
                <Spin indicator={antIcon} />
              </div>
            ) : (
              <div />
            )}
          </Row>
        </Form>
      </div>
    )
  }
}

const WrappedNormalLoginForm = Form.create({})(NormalLoginForm)

const LoginComponentContainer = connect(
  (state: State) => ({
    identity: state.login.identity,
    isFetching: (s: string) => state.fetch.fetching.has(s)
  }),
  dispatch => ({
    doLogin: (userName: string, password: string, correlationId: string) => {
      dispatch(loginActions.Login({ userName, password, [startFetch]: correlationId }))
    },
    forgotPassword: (email: string) => {
      dispatch(loginActions.LoginForgotPassword({ email }))
    },
    forgotPasswordInvalid: () => {
      dispatch(loginActions.LoginForgotPasswordNoEmail())
    }
  })
)(WrappedNormalLoginForm)

export default LoginComponentContainer



// WEBPACK FOOTER //
// ./src/users-components/login/Login.tsx